<template>
    <transition name="slide-down">
        <header v-if="displayHeader" key="site-header" class="site-header">
            <img
                class="logo"
                src="@/assets/img/mychapman-logo.svg"
                alt="MyChapman"
            />

            <UserMenu class="user-menu" />
        </header>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import UserMenu from '@/components/header/user-menu';

export default {
    name: 'SiteHeader',

    components: {
        UserMenu,
    },

    computed: {
        ...mapGetters({
            customerId: 'user/customerId',
            employeeId: 'user/employeeId',
        }),
        displayHeader() {
            return !!this.employeeId || !!this.customerId;
        },
    },
};
</script>

<style lang="scss" scoped>
.site-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0.5rem 0;
    box-shadow: $shadow-3;
    background-color: $color-gray-very-light;
    z-index: 100;

    .logo {
        display: block;
        width: 100%;
        max-width: 200px;
        margin: 0.5rem 1rem;
    }

    .user-menu {
        display: flex;
        align-items: center;
        padding: 0.5rem 1rem;
    }
}

@media screen and (max-width: 400px) {
    .site-header {
        padding: 0;

        .logo {
            max-width: 150px;
            margin: 0.25rem 0.75rem;
        }

        .user-menu {
            padding: 0.25rem 0.75rem;
        }
    }
}
</style>
